import React from 'react'

import { Button, ThemeProps } from '@hhgtech/hhg-components'
import {
  SectionContainerStyled,
  StyledContainer,
} from 'components/atoms/container/index.styled'
import FormatInnerHTML from 'components/atoms/FormatInnterHTML'
import { IExpertResume, IResumeGroup } from 'interfaces/categories.interface'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { deviceLayout } from 'styles/breakpoint'

import ResumeGroup from './ResumeGroup'
import SubArticles from './SubArticles'

const ExpertAvatarStyled = styled(StyledContainer)`
  header {
    font-size: 18px;
    font-weight: 600;
  }
  .profile,
  .about,
  .about-content {
    padding: 24px 0;
  }

  ${deviceLayout.pcLayout`
    .profile, .about {
        padding-left: 24px;
        padding-right: 24px;
        margin: 12px auto;
        border: 1px solid ${(props: ThemeProps) =>
          props.theme.mbColors.lightGray};
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
        border-radius: 16px;
    }
    .sub-article{
        padding: 16px !important;
        margin: 12px 0;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        border: 1px solid ${(props: ThemeProps) =>
          props.theme.mbColors.lightGray};
    }
    .btn-group{
        width: 50%;
    }
  `}

  .pagination {
    path {
      stroke: ${(props) => props.theme.mbColors.gray};
    }
    li[data-page-active='true'] {
      background: ${(props) => props.theme.mbColors.pink};
    }
  }

  .btn-group {
    display: flex;
    background: ${(props) => props.theme.mbColors.lightGray};
    border-radius: 12px;
    .active {
      &,
      :hover,
      :active {
        background: ${(props) => props.theme.mbColors.pink};
        border-radius: 12px;
      }
    }
    .un-active {
      &,
      :hover,
      :active {
        background: ${(props) => props.theme.mbColors.lightGray};
        border-radius: 12px;
        color: ${(props) => props.theme.mbColors.gray};
      }
    }
  }
`

const ExpertResume = (props: IExpertResume) => {
  const { formatMessage: f } = useIntl()
  const { resumeGroups, about, articles } = props
  const [btnType, setBtnType] = React.useState<boolean>(false)

  const hasResume = resumeGroups.some(
    (resume: IResumeGroup) => !!resume?.details?.length,
  )

  return (
    <ExpertAvatarStyled>
      <SectionContainerStyled className="btn-group">
        <Button
          isBlock
          size="md"
          className={!btnType ? 'active' : 'un-active'}
          onClick={() => setBtnType(false)}
        >
          {f({ id: 'expert.content.information' })}
        </Button>
        <Button
          isBlock
          size="md"
          className={btnType ? 'active' : 'un-active'}
          onClick={() => setBtnType(true)}
        >
          {f({ id: 'expert.content.my-post' })}
        </Button>
      </SectionContainerStyled>
      <SectionContainerStyled className="resume">
        {btnType ? (
          <SectionContainerStyled>
            <SubArticles articles={articles || []} />
          </SectionContainerStyled>
        ) : (
          <>
            {hasResume && (
              <SectionContainerStyled className="profile">
                {resumeGroups
                  .filter((resume: IResumeGroup) => !!resume?.details?.length)
                  .map((resumeGroup: IResumeGroup, index) => (
                    <ResumeGroup key={`${index}`} {...resumeGroup} />
                  ))}
              </SectionContainerStyled>
            )}
            {!!about && (
              <SectionContainerStyled className="about">
                <header>{f({ id: 'expert.content.about-us' })}</header>
                <FormatInnerHTML
                  as="article"
                  className="about-content"
                  template={about}
                />
              </SectionContainerStyled>
            )}
          </>
        )}
      </SectionContainerStyled>
    </ExpertAvatarStyled>
  )
}

export default ExpertResume
